import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { CREATE_CHANNEL_ACTIVATION, CREATE_CHANNEL_ACTIVATION_SUCCESS,
   CREATE_CHANNEL_ACTIVATION_ERROR } from '../redux/ChannelActivations';
import history from '../store/history';
import { SET_LOADER } from '../redux/Loader';
import { POST } from '../consts/Methods';


function* createChannelActivationFlow({ payload, }) {
  try {
    yield put(SET_LOADER({ value: true, }));
    const endpoint = `${apiRoot}/channel_activations/`;
    const { redirectPath, channelId, channel_activation, } = payload;
    const response = yield call(apiCall, {
      method: POST, endpoint, params: { channel_activation: { ...channel_activation, channel_id: channelId, }, },
    });
    yield put(CREATE_CHANNEL_ACTIVATION_SUCCESS(response));
    history.push(redirectPath);
  } catch (error) {
    yield put(CREATE_CHANNEL_ACTIVATION_ERROR(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* CreateChannelActivationSaga() {
  yield takeLatest(CREATE_CHANNEL_ACTIVATION, createChannelActivationFlow);
}
